module.exports = __webpack_public_path__ + "static/img/game_cb_1025.e513438.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_grande/game_cb_1025.png
// module id = +1R4
// module chunks = 1